import _classCallCheck from "/home/runner/work/spa-manager/spa-manager/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/spa-manager/spa-manager/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/runner/work/spa-manager/spa-manager/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/spa-manager/spa-manager/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "/home/runner/work/spa-manager/spa-manager/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/home/runner/work/spa-manager/spa-manager/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _pt from "prop-types";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import * as React from 'react';
import { debounce } from '@patternfly/react-core';
import styles from '@patternfly/react-styles/css/components/Table/table';
import { css } from '@patternfly/react-styles'; // legacy export now, RowWrapperRow can simply be typed as IRow in the future

export var RowWrapper =
/*#__PURE__*/
function (_React$Component) {
  _inherits(RowWrapper, _React$Component);

  function RowWrapper(props) {
    var _this;

    _classCallCheck(this, RowWrapper);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(RowWrapper).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "handleScroll", function (event) {
      if (!_this._unmounted) {
        _this.props.onScroll(event);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleResize", function (event) {
      if (!_this._unmounted) {
        _this.props.onResize(event);
      }
    });

    if (props.onScroll) {
      _this.handleScroll = debounce(_this.handleScroll, 100);
    }

    if (props.onResize) {
      _this.handleResize = debounce(_this.handleResize, 100);
    }

    return _this;
  }

  _createClass(RowWrapper, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this._unmounted = false;

      if (this.props.onScroll) {
        window.addEventListener('scroll', this.handleScroll);
      }

      if (this.props.onResize) {
        window.addEventListener('resize', this.handleResize);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._unmounted = true;

      if (this.props.onScroll) {
        window.removeEventListener('scroll', this.handleScroll);
      }

      if (this.props.onResize) {
        window.removeEventListener('resize', this.handleResize);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          trRef = _this$props.trRef,
          className = _this$props.className,
          onScroll = _this$props.onScroll,
          onResize = _this$props.onResize,
          isExpanded = _this$props.row.isExpanded,
          rowProps = _this$props.rowProps,
          props = _objectWithoutProperties(_this$props, ["trRef", "className", "onScroll", "onResize", "row", "rowProps"]);

      return React.createElement("tr", _extends({}, props, {
        ref: trRef,
        className: css(className, isExpanded !== undefined && styles.tableExpandableRow, isExpanded && styles.modifiers.expanded),
        hidden: isExpanded !== undefined && !isExpanded
      }));
    }
  }]);

  return RowWrapper;
}(React.Component);

_defineProperty(RowWrapper, "propTypes", {
  trRef: _pt.oneOfType([_pt.oneOfType([_pt.string, _pt.func, _pt.object]), _pt.any]),
  className: _pt.string,
  onScroll: _pt.func,
  onResize: _pt.func,
  row: _pt.shape({
    isOpen: _pt.any,
    isExpanded: _pt.any
  }),
  rowProps: _pt.any
});

_defineProperty(RowWrapper, "defaultProps", {
  className: '',
  row: {
    isOpen: undefined,
    isExpanded: undefined
  },
  rowProps: null
});